import React from 'react';
import { FormattedMessage } from 'react-intl';

type RightToolBarProps = {
    settingsDialog: 'brakes' | 'fill-level' | 'maintenance-data' | 'tires';
    onExportClick: () => void;
    isDownloading: boolean;
    leadingContent?: React.ReactNode;
    centerContent?: React.ReactNode;
    trailingContent?: React.ReactNode;
};
const CommonRightToolBar = ({
    leadingContent,
    centerContent,
    trailingContent,
    onExportClick,
    settingsDialog,
    isDownloading,
}: RightToolBarProps) => {
    return (
        <div className="common-right-toolbar space-x-10">
            {leadingContent}
            <button
                className="btn btn-default settings"
                type="button"
                onClick={() => {
                    alert(`Open settings clicked for: ${settingsDialog}.\n 
                    The actual behavior will be implemented in MANSC-23774`);
                }}
            >
                <i className="rioglyph rioglyph-cog" style={{ fontSize: 24 }} />
            </button>
            {centerContent}
            <button
                className="btn btn-default align-top"
                type="button"
                onClick={onExportClick}
                disabled={isDownloading}
            >
                <FormattedMessage id={'intl-msg:vehicle-diagnostics.button.csvExport'} />
            </button>
            {trailingContent}
        </div>
    );
};

export default CommonRightToolBar;
